// extracted by mini-css-extract-plugin
export default {"page":"HomePage_page__pXTPv","pageLinks":"HomePage_pageLinks__BXo4l","taxRulesLink":"HomePage_taxRulesLink__6KlRk"};